// extracted by mini-css-extract-plugin
export default {"bodyNormal":"chvHGzBTh","header":"crDBIup4G"};